const whDailyDc = {
  dc: 'DC',
  assessMonth: '考核月份',
  assessMonthStart: '开始月份',
  assessMonthEnd: '结束月份',
  carrierCode: '承运商代码',
  serviceProvider: '服务商',
  assessItem: '考核项目',
  category: '分类',
  categoryType: '类别',
  subCategory: '子类别',
  versionNo: '版本号',
  briefDesc: '简要描述',
  assessContent: '考核内容',
  citationClause: '援引条款',
  score: '分数',
  deduction: '扣分',
  breachExample: '违约示例描述',
  createTime: '创建时间',
  msg: {}
};
export default whDailyDc;



// WEBPACK FOOTER //
// ./src/page/assess/whDailyDc/lang/whDailyDc.zh.js